import React from "react";
import { FileText, Mail } from "lucide-react";

const sections = [
  {
    title: "1. Objet",
    body: "Les présentes conditions d'utilisation régissent l'usage de l'application mobile BoostPro, destinée à la gestion d'activité des indépendants, auto-entrepreneurs, artisans et petites entreprises (clients, factures, dépenses, véhicule, statistiques).",
  },
  {
    title: "2. Acceptation",
    body: "L'installation et l'utilisation de l'application impliquent l'acceptation pleine et entière des présentes conditions. Si vous n'acceptez pas ces conditions, vous devez désinstaller l'application.",
  },
  {
    title: "3. Utilisation de l'application",
    body: "BoostPro est mise à disposition à des fins professionnelles. L'utilisateur s'engage à utiliser l'application conformément à sa destination, à la législation en vigueur et à ne pas porter atteinte à son fonctionnement.",
  },
  {
    title: "4. Données et responsabilité",
    body: "BoostPro fonctionne en local sur l'appareil de l'utilisateur. L'utilisateur est seul responsable de la sauvegarde et de la conservation de ses données. Il est recommandé d'effectuer des sauvegardes régulières.",
  },
  {
    title: "5. Propriété intellectuelle",
    body: "L'application, son interface, son code, son logo et l'ensemble de ses éléments sont protégés par le droit de la propriété intellectuelle. Toute reproduction non autorisée est interdite.",
  },
  {
    title: "6. Limitation de responsabilité",
    body: "BoostPro est fournie « en l'état ». L'éditeur ne peut être tenu responsable des dommages directs ou indirects résultant de l'utilisation, d'une indisponibilité ou d'une perte de données liée à l'application.",
  },
  {
    title: "7. Évolution de l'application",
    body: "L'éditeur se réserve le droit de faire évoluer l'application, ses fonctionnalités et les présentes conditions à tout moment. Les utilisateurs seront informés des modifications majeures.",
  },
  {
    title: "8. Droit applicable",
    body: "Les présentes conditions sont régies par le droit français. Tout litige relatif à leur interprétation ou exécution relèvera des tribunaux français compétents.",
  },
];

export default function TermsPage() {
  return (
    <main data-testid="page-terms" className="relative pt-32 md:pt-40 pb-24">
      <div className="absolute inset-0 bg-grid opacity-20 [mask-image:radial-gradient(ellipse_at_top,black_30%,transparent_70%)]" />
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 h-[360px] w-[360px] rounded-full bg-emerald-500/15 blur-[120px]" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500/20 to-emerald-500/20 ring-1 ring-white/10">
            <FileText size={26} className="text-emerald-300" />
          </div>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl font-bold tracking-tight text-white">
            Conditions <span className="text-gradient-blue">d'utilisation</span>
          </h1>
          <p className="mt-4 text-slate-400">
            Dernière mise à jour : 10 décembre 2025
          </p>
        </div>

        <div className="mt-16 space-y-5">
          {sections.map((s, i) => (
            <section
              key={s.title}
              data-testid={`terms-section-${i}`}
              className="rounded-2xl border border-white/5 bg-slate-900/50 p-7"
            >
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white">{s.title}</h2>
              <p className="mt-3 text-slate-300 leading-relaxed">{s.body}</p>
            </section>
          ))}

          <section className="rounded-2xl border border-white/5 bg-gradient-to-br from-blue-600/10 to-emerald-500/10 p-8">
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                <Mail size={18} className="text-blue-200" />
              </div>
              <div>
                <h2 className="font-display text-xl font-semibold text-white">Contact</h2>
                <p className="mt-2 text-slate-300">
                  Pour toute question relative aux présentes conditions :
                </p>
                <a
                  data-testid="terms-email-link"
                  href="mailto:boostpro.app@gmail.com"
                  className="mt-2 inline-block text-blue-300 hover:text-blue-200 font-medium"
                >
                  boostpro.app@gmail.com
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}
